module.exports = __webpack_public_path__ + "media/images/loading-bde928ff6ca7e555f55e8956778863fe.gif";